export default {
    auth: {
        // REACT_APP_* variables are set in .env files and are accessible via process.env.
        // npm build runs production build, which uses .env.production
        tenantId: process.env.REACT_APP_AZUREAD_TENANTID,
        authority: process.env.REACT_APP_AZUREAD_AUTHORITY,
        clientId: process.env.REACT_APP_AZUREAD_CLIENTID,
        redirectUri: process.env.REACT_APP_AZUREAD_REDIRECTURI,
    },

    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
}